"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveContacts = exports.ContactDelete_OnClick = exports.Contact_OnClick = exports.InitContact = exports.ContactsLoaded = exports.tbContact = exports.cbContact = void 0;
var Cookies = require("js-cookie");
var Aanvraag = require("../Aanvraag");
var Algemeen = require("../Algemeen");
var Combobox = require("../Combobox");
var tableContacts;
var pnlContact;
var $dialogContactDelete;
var toDeleteContactNaam;
var toDeleteTr;
var Contacts = new Array;
exports.ContactsLoaded = false;
function InitContact() {
    tableContacts = $('#tableContacts');
    exports.tbContact = $('#ctl00_cphBody_tbContact');
    pnlContact = $('#ctl00_cphBody_pnlContact');
    exports.cbContact = new Combobox.ComboBox(exports.tbContact, pnlContact, undefined, tbContactOnblur, 'trContact', 'trContactInFocus');
    $dialogContactDelete = $('#dialogContactDelete');
    $dialogContactDelete.dialog({
        autoOpen: false,
        modal: true,
        width: 400,
        buttons: [
            {
                text: Algemeen.Translate('nmJa'),
                click: function () { ContactDelete(); }
            },
            {
                text: Algemeen.Translate('nmNee'),
                click: function () { ContactNoDelete(); }
            }
        ]
    });
    exports.tbContact.val(DefaultContactReadCookie());
    Algemeen.PopupControl(exports.tbContact, pnlContact);
    Algemeen.CallWebServiceGetGeneric('GetContacts', OnSuccessGetContacts);
}
exports.InitContact = InitContact;
function OnSuccessGetContacts(data, status) {
    Algemeen.CheckSessionTimeout(data);
    for (var i = 0; i < data.d.length; i++) {
        var _Contact = new Contact();
        _Contact.Naam = data.d[i].Name;
        _Contact.FromDB = true;
        Contacts.push(_Contact);
    }
    ContactsReadCookie();
    exports.ContactsLoaded = true;
    Aanvraag.CheckAllLoaded();
}
function fillContacts() {
    tableContacts.empty();
    if (Contacts.length == 0) {
        pnlContact.css('visibility', 'hidden');
    }
    else {
        for (var i = 0; i < Contacts.length; i++) {
            AddContact(Contacts[i]);
        }
    }
}
function AddContact(Contact) {
    var imgDelete = '';
    if (!Contact.FromDB) {
        imgDelete = '<img onclick="EntryPoint.ContactDelete_OnClick(this, &quot;' + Contact.Naam + '&quot;)" src="Images/cross-script-icon.png"/>';
    }
    var $tr = $('<tr class="trContact"><td class="tdContactName" onclick="EntryPoint.Contact_OnClick(&quot;' + Contact.Naam + '&quot;)">' + Contact.Naam + '</td><td>' + imgDelete + '</td></tr>');
    $tr.mouseover(function () { exports.cbContact.pnlOnMouseover(this); });
    tableContacts.append($tr);
}
function Contact_OnClick(Contact) {
    pnlContact.css('visibility', 'hidden');
    exports.tbContact.val(Contact);
}
exports.Contact_OnClick = Contact_OnClick;
function ContactDelete_OnClick(img, ContactNaam) {
    toDeleteContactNaam = ContactNaam;
    toDeleteTr = $(img).closest('.trContact');
    toDeleteTr.addClass('trContactToDelete');
    $dialogContactDelete.dialog("open");
}
exports.ContactDelete_OnClick = ContactDelete_OnClick;
function ContactDelete() {
    var iToDelete;
    for (var i = 0; i < Contacts.length; i++) {
        if (Contacts[i].Naam == toDeleteContactNaam) {
            iToDelete = i;
            break;
        }
    }
    Contacts.splice(iToDelete, 1);
    ContactsWriteCookie();
    toDeleteTr.remove();
    $dialogContactDelete.dialog("close");
}
function ContactNoDelete() {
    toDeleteTr.removeClass('trContactToDelete');
    $dialogContactDelete.dialog("close");
}
function DefaultContactWriteCookie() {
    Cookies.set("DefaultContact", exports.tbContact.val(), { expires: 365 });
}
function DefaultContactReadCookie() {
    return Cookies.get("DefaultContact");
}
function ContactsWriteCookie() {
    var CookieContacts = new Array;
    for (var i = 0; i < Contacts.length; i++) {
        if (!Contacts[i].FromDB) {
            CookieContacts.push(Contacts[i].Naam);
        }
    }
    Cookies.set("Contacts", JSON.stringify(CookieContacts.sort()), { expires: 365 });
}
function ContactsReadCookie() {
    var CookieString = Cookies.get("Contacts");
    if (CookieString != undefined) {
        var CookieContacts = $.parseJSON(CookieString);
        for (var i = 0; i < CookieContacts.length; i++) {
            if (!ContactNameInArray(CookieContacts[i])) {
                var _Contact = new Contact();
                _Contact.Naam = CookieContacts[i];
                _Contact.FromDB = false;
                Contacts.push(_Contact);
            }
        }
    }
    fillContacts();
}
function ContactNameInArray(ContactName) {
    for (var i = 0; i < Contacts.length; i++) {
        if (Contacts[i].Naam == ContactName) {
            return true;
        }
    }
    return false;
}
function ContactsInsert() {
    if (!ContactNameInArray(exports.tbContact.val())) {
        var _Contact = new Contact();
        _Contact.Naam = exports.tbContact.val();
        _Contact.FromDB = false;
        Contacts.push(_Contact);
        ContactsWriteCookie();
    }
}
function tbContactOnblur(tbValue) {
    return tbValue;
}
function SaveContacts() {
    DefaultContactWriteCookie();
    ContactsInsert();
}
exports.SaveContacts = SaveContacts;
function Contact() {
    this.Naam = '';
    this.FromDB = false;
}
